'use client';

import { useCallback, useContext } from 'react';
import DeferredStreamBoundary from '@/common/DeferredStreamBoundary';
import DeliveryPickupContext from '~/context/vdp/DeliveryPickupContext';
import type { DeliveryPickupResult } from '~/server-props/vdp/getDeliveryPickup';

export default function DeliveryPickupDeferred({
  promise
}: {
  promise: Promise<DeliveryPickupResult | undefined>;
}) {
  const {
    deliveryPickup: { setData: setDeliveryPickup },
    triggerFetchDeliveryPickup
  } = useContext(DeliveryPickupContext);

  const onResolve = useCallback(
    (data: DeliveryPickupResult | undefined) => {
      if (data) {
        setDeliveryPickup(data.response);
      } else {
        triggerFetchDeliveryPickup();
      }
    },
    [setDeliveryPickup, triggerFetchDeliveryPickup]
  );

  return (
    <DeferredStreamBoundary
      deferredKey="deliveryPickup"
      onResolve={onResolve}
      promise={promise}
    />
  );
}
